export const SITE_ORIGIN = "https://connct.ai";

export const DEFAULT_OG_IMAGE =
  "https://api.connct.ai/static/images/Connct-_Metallic_Card.png";

export const organizationJsonLd = {
  "@type": "Organization",
  "@id": `${SITE_ORIGIN}/#org`,
  name: "Connct",
  url: `${SITE_ORIGIN}/`,
  logo: `${SITE_ORIGIN}/connct-logo.png`,
  email: "info@connct.ai",
  telephone: "+91-725-995-7875",
  address: {
    "@type": "PostalAddress",
    streetAddress: "#206, 1st floor, Oxford Towers, Kodihalli",
    addressLocality: "Bengaluru",
    postalCode: "560008",
    addressCountry: "IN",
  },
  sameAs: [
    "https://www.linkedin.com/company/connct/",
    "https://www.facebook.com/connctcard",
    "https://www.instagram.com/connct.ai/",
    "https://twitter.com/connct_ai",
    "https://apps.apple.com/us/app/connct-app/id1625064091",
    "https://play.google.com/store/apps/details?id=com.connct.waves_app",
  ],
};

export const softwareApplicationJsonLd = {
  "@type": "SoftwareApplication",
  name: "Connct",
  applicationCategory: "BusinessApplication",
  operatingSystem: "iOS, Android, Web",
  description:
    "Digital business card and contact management app. Share via NFC, QR or link; capture and export leads; team analytics.",
  offers: [
    {
      "@type": "Offer",
      name: "Pro (international)",
      price: "11.97",
      priceCurrency: "USD",
    },
    {
      "@type": "Offer",
      name: "Pro (India)",
      price: "999",
      priceCurrency: "INR",
    },
  ],
  publisher: { "@id": `${SITE_ORIGIN}/#org` },
};
